import type { CSSProperties } from "react";
import { ColorType } from "@/theme/colors";

interface CreferenceInlineRootStyleInput {
  disabled: boolean;
  isUnresolved: boolean;
  style?: CSSProperties;
}

interface CreferenceInlineTextStyleInput {
  linkedLabelTextStyle: CSSProperties;
}

export function getCreferenceInlineRootStyle({
  disabled,
  isUnresolved,
  style,
}: CreferenceInlineRootStyleInput): CSSProperties {
  return {
    display: "inline-flex",
    alignItems: "center",
    gap: "5px",
    flexWrap: "wrap",
    maxWidth: "100%",
    verticalAlign: "baseline",
    opacity: disabled || isUnresolved ? 0.7 : 1,
    ...style,
  };
}

export function getCreferenceInlineLeadingStyle(): CSSProperties {
  return {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  };
}

export function getCreferenceInlineTextColor(
  isUnresolved: boolean,
): ColorType {
  return isUnresolved ? ColorType.White : ColorType.Accent;
}

export function getCreferenceInlineTextOpacity(
  isUnresolved: boolean,
): number {
  return isUnresolved ? 0.85 : 0.95;
}

export function getCreferenceInlineTextStyle({
  linkedLabelTextStyle,
}: CreferenceInlineTextStyleInput): CSSProperties {
  return {
    ...linkedLabelTextStyle,
    lineHeight: 1.25,
  };
}
